'use client';
import React from 'react';
import Hooks from '@benzinga/hooks';
import { FeedbackForm } from './FeedbackForm';

export interface FeedBackProps {
  className?: string;
  isShown?: boolean;
}

export const FeedbackFormCaller: React.FC<React.PropsWithChildren<FeedBackProps>> = props => {
  const [isFeedbackFormShown, setFeedbackFormShown] = React.useState<boolean>(false);
  const prevIsShown = Hooks.usePrevious(props.isShown);

  React.useEffect(() => {
    const { isShown } = props;
    if (prevIsShown !== undefined && !!prevIsShown !== !!isShown) {
      toggleFeedbackForm();
    }
  });

  const toggleFeedbackForm = () => {
    setFeedbackFormShown(!isFeedbackFormShown);
  };

  const closeFeedbackForm = () => {
    setFeedbackFormShown(false);
  };

  const { children, className } = props;
  return (
    <div>
      <FeedbackForm handleClose={closeFeedbackForm} isVisible={isFeedbackFormShown} onSubmit={closeFeedbackForm} />
      <button className={className} onClick={toggleFeedbackForm}>
        {children}
      </button>
    </div>
  );
};
